﻿/* 
Object:         Node
Description:    Logic and events for the module Node (ManageNode)
Used in:        Node
*/

window.node = function () {

    return {
        /**
         * Initialize form
         */
        initializeForm: function (id) {
            if (id > 0) {
                $("#NodeTypeId").data("kendoDropDownList").enable(false);
            }
        },

        /**
         * Init (binding button actions) Overview grid
         */
        initialize: function () {
            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("Node/Add");
            });
        },

        /**
         * Delete item from grid
         * @param {any} e
         */
        deleteItem: function (e) {

            var event = e;
            var data = this;

            function callbackYes(event, data) {

                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

                // Post Data
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("Node/Delete?nodeId=" + dataItem.NodeId),
                    success: function (responseData) {

                        // Refresh datasource grid 
                        $("#NodeGrid").data("kendoGrid").dataSource.read();

                        // Do callbackJS 
                        if (responseData.CallbackJS != null && responseData.CallbackJS != undefined) {
                            Function(responseData.CallbackJS)();
                            // execute callbackJS content (dont wrap more than one function call in one function as a wrapper, that will not execute)
                        }

                        // Show error if any
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ',
                                responseData.Message, [{
                                    text: 'Ok',
                                    action: function () {
                                        main.closePopup();
                                    }, primary: true
                                }]);
                        }
                    }
                });
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });

        },

        /**
         * Update a item from grid
         * @param {any} e
         */
        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Name;

            // Edit mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Node/Edit?nodeId=" + dataItem.NodeId + "&breadcrumbLabel=" + label);
        },

        /**
         * Show item from grid
         * @param {any} e
         */
        showItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Name;

            // Show mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Node/Show?nodeId=" + dataItem.NodeId + "&breadcrumbLabel=" + label);
        }
    }
}();